import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';

interface HeaderLinkProps {
  url: string;
  text: string;
}

const Wrapper = styled.div`
  margin: 8px auto 0;
  background: 0 0;
  border: 0;
  font-size: 12px;
  line-height: 18px;
  color: #ff642e;
  text-decoration: underline;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 500;
  a {
    font-size: 12px;
    line-height: 18px;
    color: #ff642e;
    font-weight: 500;
    text-transform: uppercase;
    text-decoration: underline;
  }
`;

// @TODO use <Link to={url}>
export const HeaderLink: React.FC<PropsWithChildren<HeaderLinkProps>> = ({ url, text }) => (
  <Wrapper>
    <a href={url}>{text}</a>
  </Wrapper>
);
